import base from './base';
import { Ienvironment } from './ienvironment';

export const environment:Ienvironment = {
  ...base,
  production: false,
  appId: 'd5d3569e-4a6b-4b63-9251-0ca6e55d410e',
  invoiceServiceApiBaseUrl: 'https://invoiceservice-dev.allinoneinvoice.com',
  communicationserviceApiBaseUrl: 'https://communicationservice-dev.allinoneinvoice.com',
  authServiceApiBaseUrl: 'https://authservice-dev.allinoneinvoice.com',
  userServiceApiBaseUrl: 'https://userservice-dev.allinoneinvoice.com'
};
